// ===========================================
// 首先：立即修复 Element UI setAttribute 错误
// ===========================================
(function() {
  // 安全包装 DOM 方法
  const safeWrap = (fn, name) => {
    return function(...args) {
      if (!this || this.nodeType === undefined) {
        return
      }
      try {
        return fn.apply(this, args)
      } catch (e) {
        console.warn(`${name} 错误已忽略:`, e.message)
      }
    }
  }
  
  // 安全化 setAttribute 和 removeAttribute
  Element.prototype.setAttribute = safeWrap(Element.prototype.setAttribute, 'setAttribute')
  Element.prototype.removeAttribute = safeWrap(Element.prototype.removeAttribute, 'removeAttribute')
})()

// ===========================================
// 接下来是正常的 main.js 内容
// ===========================================
import Vue from 'vue'
import Bus from '@/api/bus'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import format from 'date-fns/format'
import './plugins/axios'
import axios from 'axios'
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)
Vue.prototype.$http = axios
Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(Bus)

import preventClick from '@/common/utils/preventClick'
Vue.use(preventClick)

import VueAreaLinkage from 'vue-area-linkage'
import 'vue-area-linkage/dist/index.css'

import '@/assets/css/all.less'
import '@/assets/css/homethree.less'
import '@/style/css/main.less'

import comFun from '@/api/comFun'
import { selectEntrantsSeoPcList } from '@/api/home'
import { getDomain } from '@/api/cookies'
Vue.use(comFun)

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

Vue.use(VueAreaLinkage)

Vue.filter('format', function (value, formatStr) {
  let time = new Date(value ? value.replace(/-/g, '/') : '')
  return format(time === 'Invalid Date' ? new Date(value) : time, formatStr)
})

Vue.filter('ellipsis', function (value, number) {
  if (!value) return ''
  if (value.length > number) {
    return value.slice(0, number) + '...'
  }
  return value
})

router.beforeEach(async (to, from, next) => {
  // 路由切换时关闭弹窗
  try {
    const dialogWrappers = document.querySelectorAll('.el-dialog__wrapper')
    dialogWrappers.forEach(wrapper => {
      const closeBtn = wrapper.querySelector('.el-dialog__headerbtn')
      if (closeBtn && wrapper.style.display !== 'none') {
        closeBtn.click()
      }
    })
    const poppers = document.querySelectorAll('.el-select-dropdown, .el-dropdown-menu, .el-popper')
    poppers.forEach(popper => {
      popper.style.display = 'none'
    })
  } catch (e) {
    console.warn('关闭弹窗时出错:', e)
  }

  let seoval = sessionStorage.getItem('seo')
  if ((!seoval || seoval === 'null' || seoval === 'undefined') || (seoval && seoval.length === 0) || to.path === '/') {
    if (localStorage.getItem('domainjwt')) {
      try {
        const res = await selectEntrantsSeoPcList()
        if (res && res.data) {
          sessionStorage.setItem('seo', JSON.stringify(res.data))
        }
      } catch (e) {
        console.warn('获取 SEO 数据失败:', e)
      }
    }
  }

  let seoData = sessionStorage.getItem('seo')
  if (seoData) {
    try {
      seoData = JSON.parse(seoData)
    } catch (e) {
      seoData = null
    }
  }

  if (seoData && Array.isArray(seoData) && seoData.length > 0) {
    for (const item of seoData) {
      if (item.typeName === to.name) {
        document.title = item.seoTitle || ''
        const keywordsMeta = document.querySelector('meta[name="keywords"]')
        const descriptionMeta = document.querySelector('meta[name="description"]')
        if (keywordsMeta) keywordsMeta.setAttribute('content', item.seoKey || '')
        if (descriptionMeta) descriptionMeta.setAttribute('content', item.seoDescribe || '')
        break
      } else if (to.name === '项目频道页' && item.kindId === to.query.id) {
        document.title = item.seoTitle || ''
        const keywordsMeta = document.querySelector('meta[name="keywords"]')
        const descriptionMeta = document.querySelector('meta[name="description"]')
        if (keywordsMeta) keywordsMeta.setAttribute('content', item.seoKey || '')
        if (descriptionMeta) descriptionMeta.setAttribute('content', item.seoDescribe || '')
        break
      } else {
        document.title = getDomain() ? getDomain().name : ''
        const keywordsMeta = document.querySelector('meta[name="keywords"]')
        const descriptionMeta = document.querySelector('meta[name="description"]')
        if (keywordsMeta) keywordsMeta.setAttribute('content', '')
        if (descriptionMeta) descriptionMeta.setAttribute('content', '')
      }
    }
  } else {
    document.title = getDomain() ? getDomain().name : ''
    const keywordsMeta = document.querySelector('meta[name="keywords"]')
    const descriptionMeta = document.querySelector('meta[name="description"]')
    if (keywordsMeta) keywordsMeta.setAttribute('content', '')
    if (descriptionMeta) descriptionMeta.setAttribute('content', '')
  }

  next()
})

// 全局错误处理
const originalErrorHandler = Vue.config.errorHandler
Vue.config.errorHandler = function(err, vm, info) {
  if (err && err.message) {
    const msg = err.message.toLowerCase()
    if (msg.includes('setattribute') || msg.includes('cannot read properties of null')) {
      console.warn('已忽略错误:', err.message)
      return
    }
  }
  if (originalErrorHandler) {
    originalErrorHandler.call(this, err, vm, info)
  } else {
    console.error(err)
  }
}

window.onerror = function(message, source, lineno, colno, error) {
  if (message && (message.toLowerCase().includes('setattribute') || message.toLowerCase().includes('cannot read properties of null'))) {
    console.warn('已忽略全局错误:', message)
    return true
  }
  return false
}

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
